import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LedgerEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-balance-sheet',
  templateUrl: './balance-sheet.component.html',
  styleUrls: ['./balance-sheet.component.css']
})
export class BalanceSheetComponent implements OnInit {
  totalCashFlow: number;
  zero: boolean = true;
  ready = false;
  constructor(public authService: AuthService, private db: AngularFirestore, private ledgerService: LedgerService) { }
  ngOnInit() {
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    this.getLedger();

    this.getBalanceSheet();
    this.getRetainedIncome();
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.LedgerEntry.user = this.userProfile.displayName;
    this.LedgerEntry.userEmail = this.userProfile.email;
    this.LedgerEntry.userNumber = this.userProfile.number;

    this.LedgerEntry.userId = this.user.uid;
  }

  userProfile;
  user;
  addingNew = true;
  backup = false;
  fullView = false;
  balanceSheet = { construct: {}, "debitCash": [], "totalDebitCash": 0, "creditCash": [], "totalCreditCash": 0, "debitA/R": [], "totalDebitA/R": 0, "creditA/R": [], "totalCreditA/R": 0, "debitD/P": [], "totalDebitD/P": 0, "creditD/P": [], "totalCreditD/P": 0, "debitA/P": [], "totalDebitA/P": 0, "creditA/P": [], "totalCreditA/P": 0, "FixedAsset": [], "totalFixedAsset": 0, "debitTaxesPayable": [], "totalDebitTaxesPayable": 0, "creditTaxesPayable": [], "totalCreditTaxesPayable": 0, "debitCapital": [], "totalDebitCapital": 0, "creditCapital": [], "totalCreditCapital": 0, "debitNetIncome": [], "totalDebitNetIncome": 0, "creditNetIncome": [], "totalCreditNetIncome": 0, "totalCreditRetainedearnings": 0, "totalDebitRetainedearnings": 0 };
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0, "netIncome": 0 };
  ledger: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;

  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  entryToEdit: any = {};
  autoComplete = {
    TXN: {},
    supplier: {},
    shipmentNumber: {},
    codeCredit: {},
    codeDebit: {},
    creditName: {},
    date: {},
    debitName: {},
  };
  autoCompleteKeys = {
    supplier: {},
    shipmentNumber: {},
    codeDebit: {},
    codeCredit: {},
    debitName: {},
    creditName: {},

  };
  autoCompleteKeysCode = {
    codeDebit: {},
    codeCredit: {},


  };
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = [];
  LedgerEntry: LedgerEntry = {
    id: "",
    TXN: "",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "",
    codeDebit: "",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: ""
  }
  generalLedgerCollection = { generalLedger: [] };
  // Math.round((num + Number.EPSILON) * 100) / 100
  addNew() {
    if (this.addingNew) {
      //(<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12";
      this.addingNew = !this.addingNew;
    } else {
      //(<HTMLInputElement>document.getElementById('addForm')).className = "col s1";
      this.addingNew = !this.addingNew;

    }
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100
  }
  getLedger() {
    this.ledger = this.db.collection("generalLedger").snapshotChanges().pipe(map(actions => {
      this.totalDebit = 0; this.totalCredit = 0; this.totalCashFlow = 0;
      return actions.map(a => {
        //Get document data
        const data = a.payload.doc.data() as LedgerEntry;
        this.totalDebit += this.roundValue(data.debitValue);
        this.totalCredit += this.roundValue(data.creditValue);
        this.totalCashFlow += this.roundValue(data.cashFlow);
        //Get document id
        const id = a.payload.doc.id;
        ////console.log(data);
        this.addAutoComplete(data)
        this.generalLedgerCollection.generalLedger.push(data);
        let unix_timestamp = data.date['seconds']
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds.
        var date = new Date(unix_timestamp * 1000); //console.log(date);
        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        var seconds = "0" + date.getSeconds();

        // Will display time in 10:30:23 format
        var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        Math.abs(2 % 2) == 1
        //Use spread operator to add the id to the document data
        return { id, date, data };
      });
    }));
  }
  isToday(dateParameter) {
    var today = new Date();
    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  updateValueOnAutocomplete() {
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];

      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;

      if (val) {
        if (key != 'shipmentNumber') {
          me.LedgerEntry[key] = val;
        }
        else {
          me.LedgerEntry[key] = Number.parseFloat(val);
        }
        //console.log(me.LedgerEntry[key]);
      }
      //


    });
  }
  addAutoComplete(data) {
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "") {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);

      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  getBalanceSheet(): void {
    let date = this.LedgerEntry.date;
    let db = this.db;//handle case zero ? ask dad ?
    //get Zero {مصاريف عامة للشحنة}
    let balance = ["Debit", "Credit", "debit", "credit"];
    var me = this;

    setTimeout(function () {

      Object.keys(me.autoCompleteKeysCode).forEach(function (key) {
      //  console.log(key, me.autoComplete)
        var that = me;
        // for (var b = 0; b < 2; b++) {
        Object.keys(me.autoComplete[key]).forEach(function (keyref) {
          // console.log(key, keyref)


          let collection = that.db.collection("generalLedger", ref => ref.where(key, '==', keyref))
          if (keyref != "-")
            collection.get().toPromise()
              .then((querySnapshot: QuerySnapshot<DocumentData>) => {
                querySnapshot.forEach((doc: any) => {
                  const data = doc.data() as LedgerEntry;
                  var Index; var iIndex;
                  //Get document id
                  const id = doc.id;
                  //console.log(data);
                  if (key == "codeDebit") { Index = 0; iIndex = 1; }
                  else { Index = 1; iIndex = -1; }
                //  console.log(key, keyref, balance[Index + 2], balance[Index + 2 + iIndex])
                  var _keyref = keyref.replace(" ", "");
                  if (!that.balanceSheet[balance[Index + 2] + _keyref]) {
                    that.balanceSheet[balance[Index + 2] + _keyref] = [];
                    that.balanceSheet["total" + balance[Index] + _keyref] = 0;
                  }
                  that.balanceSheet[balance[Index + 2] + _keyref].push(data);
                  that.balanceSheet["total" + balance[Index] + _keyref] += that.roundValue(data["debitValue"]);

                  //construct
                  if (!that.balanceSheet.construct[balance[Index + 2]]) {
                    that.balanceSheet.construct[balance[Index + 2]] = {};
                  }
                  if (!that.balanceSheet.construct[balance[Index + 2]][_keyref]) {
                    that.balanceSheet.construct[balance[Index + 2]][_keyref] = {};
                  }
                  if (!that.balanceSheet.construct[balance[Index + 2]][_keyref][data[balance[Index + 2] + "Name"]]) {
                    that.balanceSheet.construct[balance[Index + 2]][_keyref][data[balance[Index + 2] + "Name"]] = 0;
                  }
                  that.balanceSheet.construct[balance[Index + 2]][_keyref][data[balance[Index + 2] + "Name"]] += data.debitValue;

                  if (!that.balanceSheet.construct[balance[Index + 2 + iIndex]]) { that.balanceSheet.construct[balance[Index + 2 + iIndex]] = {}; }
                  if (!that.balanceSheet.construct[balance[Index + 2 + iIndex]][_keyref]) {
                    that.balanceSheet.construct[balance[Index + 2 + iIndex]][_keyref] = {};
                  }
                  if (!that.balanceSheet.construct[balance[Index + 2 + iIndex]][_keyref][data[balance[Index + 2] + "Name"]]) {
                    that.balanceSheet.construct[balance[Index + 2 + iIndex]][_keyref][data[balance[Index + 2] + "Name"]] = 0;
                  }
                  // that.balanceSheet.construct[balance[Index + 2 + iIndex]][_keyref][data[balance[Index + 2 + iIndex] + "Name"]] += data.debitValue;

                  //Use spread operator to add the id to the document data
                  return { id, date, data };
                })
              });

        });
        // }
      });

    }, 1000);


    // let collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "Cash"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitCash"].push(data);
    //       this.balanceSheet["totalDebitCash"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "Cash"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditCash"].push(data);
    //       this.balanceSheet["totalCreditCash"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });


    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "A/R"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitA/R"].push(data);
    //       this.balanceSheet["totalDebitA/R"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "A/R"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditA/R"].push(data);
    //       this.balanceSheet["totalCreditA/R"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "D/P"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitD/P"].push(data);
    //       this.balanceSheet["totalDebitD/P"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "D/P"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditD/P"].push(data);
    //       this.balanceSheet["totalCreditD/P"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "A/P"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitA/P"].push(data);
    //       this.balanceSheet["totalDebitA/P"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "A/P"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditA/P"].push(data);
    //       this.balanceSheet["totalCreditA/P"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });


    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "Fixed Asset"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["FixedAsset"].push(data);
    //       this.balanceSheet["totalFixedAsset"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "Taxes Payable"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditTaxesPayable"].push(data);
    //       this.balanceSheet["totalCreditTaxesPayable"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });


    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "Taxes Payable"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitTaxesPayable"].push(data);
    //       this.balanceSheet["totalDebitTaxesPayable"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });


    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "Capital"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditCapital"].push(data);
    //       this.balanceSheet["totalCreditCapital"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "Capital"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitCapital"].push(data);
    //       this.balanceSheet["totalDebitCapital"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

    // collection = db.collection("generalLedger", ref => ref.where('codeDebit', '==', "Net Income"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["debitNetIncome"].push(data);
    //       this.balanceSheet["totalDebitNetIncome"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });


    // collection = db.collection("generalLedger", ref => ref.where('codeCredit', '==', "Net Income"))
    // collection.get().toPromise()
    //   .then((querySnapshot: QuerySnapshot<DocumentData>) => {
    //     querySnapshot.forEach((doc: any) => {
    //       const data = doc.data() as LedgerEntry;
    //       //Get document id
    //       const id = doc.id;
    //       //console.log(data);
    //       this.balanceSheet["creditNetIncome"].push(data);
    //       this.balanceSheet["totalCreditNetIncome"] += this.roundValue(data["debitValue"]);
    //       //Use spread operator to add the id to the document data
    //       return { id, date, data };
    //     })
    //   });

  //  console.log(this.balanceSheet);
  }
  getRetainedIncome() {
    //console.log("keyS");
    var it = this;
    setTimeout(function () {
      var that = it;
      Object.keys(it.autoComplete.supplier).forEach(function (keyS) {
        var these = that; //console.log(keyS);
        Object.keys(that.autoComplete.shipmentNumber).forEach(function (keyN) {
          these.getShipmentStatement(keyS, keyN); //console.log(keyN);
        })
      })
      it.ready = true;
    //  console.log(it.incomeStatement);
    }, 1500)
  }
  getShipmentStatement(sup, ship): void {
    //this.updateValueOnAutocomplete();
    //console.log("filter called");

    let supplier = sup;
    let shipmentNumber = Number.parseInt(ship);
    let txn = this.LedgerEntry.TXN;
    let date = this.LedgerEntry.date;
    let dbCode = this.LedgerEntry.codeDebit;
    let crCode = this.LedgerEntry.codeCredit;
    //console.log("filter", supplier, shipmentNumber, txn, date, dbCode, crCode);

    let db = this.db;//handle case zero ? ask dad ?
    //get Zero {مصاريف عامة للشحنة}
    let collection = db.collection("generalLedger", ref => ref.where('debitName', '==', "Zero {مصاريف عامة للشحنة}").where('codeDebit', '==', "Exp"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["zero"] = [];
        this.incomeStatement["totalZero"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["zero"].push(data);
          this.incomeStatement["totalZero"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, date, data };
        })
      });


    //get expOp
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', "Zero").where('shipmentNumber', '==', 0).where('codeDebit', '==', "Exp Op."))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["expOp"] = [];
        this.incomeStatement["totalExpOp"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["expOp"].push(data);
          this.incomeStatement["totalExpOp"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, date, data };
        })
      });


    //get expOpCr
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', "Zero").where('shipmentNumber', '==', 0).where('codeCredit', '==', "Exp Op."))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["expOpCr"] = [];
        this.incomeStatement["totalExpOpCr"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["expOpCr"].push(data);
          this.incomeStatement["totalExpOpCr"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, date, data };
        })
      });


    //console.log("filter check", this.autoCompleteArray.includes(supplier) && this.safeToFilter, this.autoCompleteArray , supplier, this.safeToFilter);
    if (this.autoCompleteArray.includes(supplier) && this.safeToFilter) {
      this.zero = false;
      //console.log("filterstart");
      let db = this.db;//handle case zero ? ask dad ?
      //get container
      let collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Container"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["container"] = [];
          this.incomeStatement["totalContainer"] = 0;
          this.incomeStatement["totalCogs"] = 0;
          querySnapshot.forEach((doc: any) => {
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["container"].push(data);
            this.incomeStatement["totalContainer"] -= data["debitValue"];
            this.incomeStatement["totalCogs"] -= data["debitValue"];
            //Use spread operator to add the id to the document data
            return { id, date, data };
          })
        });
      //get direct cost
      collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Direct Cost"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["directCost"] = [];
          this.incomeStatement["totalDirectCost"] = 0;
          querySnapshot.forEach((doc: any) => {
            //Get document data
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["directCost"].push(data);
            this.incomeStatement["totalDirectCost"] -= data["debitValue"];
            this.incomeStatement["totalCogs"] -= data["debitValue"];
            //Use spread operator to add the id to the document data
            return { id, date, data };
          });
        });

      //get direct cost Cr
      collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Direct Cost"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["directCostCr"] = [];
          this.incomeStatement["totalDirectCostCr"] = 0;
          querySnapshot.forEach((doc: any) => {
            //Get document data
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["directCostCr"].push(data);
            this.incomeStatement["totalDirectCostCr"] += this.roundValue(data["debitValue"]);
            this.incomeStatement["totalCogs"] += this.roundValue(data["debitValue"]);
            //Use spread operator to add the id to the document data
            return { id, date, data };
          });
        });





      //get Exp
      collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Exp"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["exp"] = [];
          this.incomeStatement["totalExp"] = 0;
          querySnapshot.forEach((doc: any) => {
            //Get document data
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["exp"].push(data);
            this.incomeStatement["totalExp"] -= data["debitValue"];
            //Use spread operator to add the id to the document data
            return { id, date, data };
          });
        });

      //get provisional tax
      collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "provisional tax"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["taxes"] = [];
          this.incomeStatement["totalTaxes"] = 0;
          querySnapshot.forEach((doc: any) => {
            //Get document data
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["taxes"].push(data);
            this.incomeStatement["totalTaxes"] -= data["debitValue"];
            //Use spread operator to add the id to the document data
            return { id, date, data };
          });
        });

      //get Sales
      collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Sales"))
      collection.get().toPromise()
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
          this.incomeStatement["sales"] = [];
          this.incomeStatement["totalSales"] = 0;
          querySnapshot.forEach((doc: any) => {
            //Get document data
            const data = doc.data() as LedgerEntry;
            //Get document id
            const id = doc.id;
            //console.log(data);
            this.incomeStatement["sales"].push(data);
            this.incomeStatement["totalSales"] += this.roundValue(data["debitValue"]);
            //Use spread operator to add the id to the document data
            return { id, date, data };
          });
        });
      // this.incomeStatement["netIncome"]++;
      this.incomeStatement["netIncome"] += this.incomeStatement.totalSales + this.incomeStatement.totalCogs + this.incomeStatement.totalExp + this.incomeStatement.totalTaxes;
    }
    else { this.zero = true; }
    //console.log(this.incomeStatement);
  }



}
